var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-swatches.j2"] = require( "macros/product-swatches.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-product-tile-swatches.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "displaySwatches") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")) {
env.getTemplate("macros/product-swatches.j2", false, "core/templates/core-product-tile-swatches.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("swatches", t_1);
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_extra_large")) {
output += "\n    \t";
var t_4;
t_4 = 7;
frame.set("maxSwatchDisplay", t_4, true);
if(frame.topLevel) {
context.setVariable("maxSwatchDisplay", t_4);
}
if(frame.topLevel) {
context.addExport("maxSwatchDisplay", t_4);
}
output += "\n    ";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_large")) {
output += "\n    \t";
var t_5;
t_5 = 5;
frame.set("maxSwatchDisplay", t_5, true);
if(frame.topLevel) {
context.setVariable("maxSwatchDisplay", t_5);
}
if(frame.topLevel) {
context.addExport("maxSwatchDisplay", t_5);
}
output += "\n    ";
;
}
else {
output += "\n    \t";
var t_6;
t_6 = 4;
frame.set("maxSwatchDisplay", t_6, true);
if(frame.topLevel) {
context.setVariable("maxSwatchDisplay", t_6);
}
if(frame.topLevel) {
context.addExport("maxSwatchDisplay", t_6);
}
output += "\n    ";
;
}
;
}
if(runtime.contextOrFrameLookup(context, frame, "tileTemplate") == "title_price_num_colors") {
output += "\n        ";
output += runtime.suppressValue((lineno = 13, colno = 34, runtime.callWrap(runtime.memberLookup((t_1),"displayNumColors"), "swatches[\"displayNumColors\"]", context, [runtime.contextOrFrameLookup(context, frame, "tile")])), env.opts.autoescape);
output += "\n\n    ";
;
}
else {
output += "\n\n        ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"skuInfo")),"primarySlice")),"sliceItems")) > runtime.contextOrFrameLookup(context, frame, "maxSwatchDisplay")) {
output += "\n\n            ";
output += runtime.suppressValue((lineno = 19, colno = 37, runtime.callWrap(runtime.memberLookup((t_1),"displaySwatches"), "swatches[\"displaySwatches\"]", context, [runtime.contextOrFrameLookup(context, frame, "tile"),true,runtime.contextOrFrameLookup(context, frame, "maxSwatchDisplay") - 1])), env.opts.autoescape);
output += "\n\n        ";
;
}
else {
output += "\n\n            ";
output += runtime.suppressValue((lineno = 23, colno = 37, runtime.callWrap(runtime.memberLookup((t_1),"displaySwatches"), "swatches[\"displaySwatches\"]", context, [runtime.contextOrFrameLookup(context, frame, "tile"),true,runtime.contextOrFrameLookup(context, frame, "maxSwatchDisplay")])), env.opts.autoescape);
output += "\n\n        ";
;
}
output += "\n\n    ";
;
}
output += "\n\n";
})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-product-tile-swatches.j2"] , dependencies)